import { ProblemDetails } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
/**
 * Error messages for file upload requests only. Kept apart from Notifier so that other pages'
 * error handling is unchanged.
 */
export class UploadErrorHelper {
    /**
     * Returns why an upload was rejected, or null when the error is not an upload rejection
     * (in which case the caller should fall back to Notifier's usual handling).
     */
    static getRejectionReason(ex) {
        try {
            // Rejected by the web server or IIS before reaching the API, so there is no problem
            // details body to read (IIS sends an HTML page).
            if ((ex === null || ex === void 0 ? void 0 : ex.status) === 413)
                return UploadErrorHelper.RequestTooLargeMessage;
            if ((ex === null || ex === void 0 ? void 0 : ex.status) !== 400 || !ex.response)
                return null;
            // The server's validation failures carry a generic title; the reasons are in the detail.
            const problem = ex.result instanceof ProblemDetails ? ex.result : ProblemDetails.fromJS(JSON.parse(ex.response));
            return (problem === null || problem === void 0 ? void 0 : problem.detail) ? `${problem.detail}` : null;
        }
        catch (e) {
            return null;
        }
    }
    /**
     * The rejection reason when there is one, otherwise Notifier's usual message.
     */
    static getMessage(ex) {
        var _a;
        return (_a = UploadErrorHelper.getRejectionReason(ex)) !== null && _a !== void 0 ? _a : Notifier.getErrorMessage(ex);
    }
    /**
     * Shows the rejection reason as an error when there is one, otherwise defers to
     * Notifier.onServerError (which also handles HTML error pages).
     */
    static notify(ex) {
        const reason = UploadErrorHelper.getRejectionReason(ex);
        if (reason)
            Notifier.onError(reason);
        else
            Notifier.onServerError(ex);
    }
}
UploadErrorHelper.RequestTooLargeMessage = "The upload is too large. Please choose smaller files, or fewer files at once.";
